import { useState, useEffect, useMemo } from 'react';
import { useStore } from '../contexts/StoreContext';
import { useAuth } from '../contexts/AuthContext';
import { NotificationService } from '../services/notification-service';
import type { NotificationSettings } from '../services/notification-service';
import { useInboxFeed } from './useInboxFeed';

export function useNotifications() {
  const { store } = useStore();
  const { wallet } = useAuth();
  const userId = wallet?.address ?? 'anonymous';
  const [settings, setSettings] = useState<NotificationSettings>({ enabled: true, pushEnabled: false });
  const inboxFeed = useInboxFeed();

  const service = useMemo(() => {
    if (!store) return null;
    return new NotificationService(store, userId);
  }, [store, userId]);

  useEffect(() => {
    if (!service) return;
    service.loadSettings().then(setSettings).catch(() => {});
  }, [service]);

  const updateSettings = async (newSettings: NotificationSettings) => {
    if (!service) return;
    await service.saveSettings(newSettings);
    setSettings(newSettings);
  };

  return {
    service,
    unreadCount: inboxFeed.unreadCount,
    settings,
    updateSettings,
    markAllRead: inboxFeed.markAllRead,
  };
}
